// @core/api/endpoints/secret/undelete_kv_secret_versions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UndeleteKvSecretVersionsRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Undelete KV secret versions
 * Restores previously soft-deleted versions of a KV secret. Specify the version numbers to restore.
 */
export async function UndeleteKvSecretVersions(
  engine_id: string,
  path: string,
  data: UndeleteKvSecretVersionsRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/kv/undelete/:path`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':path', encodeURIComponent(path));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
